<template>
	<div class="container">
		<div class="main_box">
			<!--联系我们-->
			<fixed></fixed>
			<!--联系我们-->
			<!--导航-->
			<navbar></navbar>
			<!--导航-->
			<!--引导块-->
			<div
				v-if="infoData"
				class="tips_box"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="tips_main">
					<span>Home&nbsp;&nbsp;>&nbsp;&nbsp;Products&nbsp;&nbsp;>&nbsp;&nbsp;{{ infoData.parent_name }}&nbsp;&nbsp;>&nbsp;&nbsp;</span>{{ infoData.title }}
				</div>
			</div>
			<!--引导块-->
			<!--banner-->
			<div v-if="infoData" class="banner_box">
				<div class="banner_main">
					<div class="left"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="300"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="title1">
							CorDx&ensp;Tyfast
						</div>
						<div class="title2">
							<img src="../../assets/rsv/25.webp" />
						</div>
						<div class="text">
							Backed by the most recent U.S. clinical<br />
							evidence, ready for today’s post-COVID reality.
						</div>
						<div class="list_box">
							<div class="list_el">
								<img src="../../assets/rsv/7.webp" />
								<div>Nasal Swab</div>
							</div>
							<div class="list_el">
								<img src="../../assets/rsv/9.webp" />
								<div>Accurate</div>
							</div>
							<div class="list_el">
								<img src="../../assets/rsv/8.webp" />
								<div>User-Friendly</div>
							</div>
						</div>
						<div class="rz_box">
							<img src="../../assets/rsv/10.webp" />
						</div>
						<div class="btn_box">
							<img src="../../assets/rsv/11.webp" @click="goContact" />
						</div>
					</div>
					<div class="right"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<van-image width="100%" height="auto" :src="infoData.url" />
					</div>
				</div>
				<div v-if="false" class="img_box">
					<div class="title"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<img src="../../assets/rsv/26.webp" />
					</div>
					<img
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="300"
						data-aos-offset="0"
						data-aos-once="true"
						src="../../assets/rsv/27.webp"
						class="img"
					/>
				</div>
				<div class="icon" style="left: -80px;bottom: 200px;">
					<img src="../../assets/rsv/4.webp" style="width: 350px;" />
				</div>
				<div class="icon" style="right: 30px;bottom: 450px;">
					<img src="../../assets/rsv/4.webp" style="width: 400px;" />
				</div>
				<div class="icon" style="right: 160px;bottom: 200px;">
					<img src="../../assets/rsv/4.webp" style="width: 70px;" />
				</div>
			</div>
			<!--banner-->
			<!--块1-->
			<div class="block_1">
				<div class="block_1_main">
					<div class="list_box">
						<div class="list_el"
							data-aos="fade-up"
							data-aos-duration="400"
							data-aos-delay="500"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<img src="../../assets/rsv/13.webp" />
							<div>Rapid Results</div>
						</div>
						<div class="list_el"
							data-aos="fade-up"
							data-aos-duration="400"
							data-aos-delay="800"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<img src="../../assets/rsv/14.webp" />
							<div>Noninvasive</div>
						</div>
						<div class="list_el"
							data-aos="fade-up"
							data-aos-duration="400"
							data-aos-delay="1100"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<img src="../../assets/rsv/12.webp" />
							<div>Streamlined</div>
						</div>
						<div class="list_el"
							data-aos="fade-up"
							data-aos-duration="400"
							data-aos-delay="1400"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<img src="../../assets/rsv/15.webp" />
							<div>Quality</div>
						</div>
					</div>
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div class="block_2">
				<div class="block_2_main">
					<div class="title_box"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="title">WHAT IS INSIDE</div>
						<div class="tips">///////////////////////////////////////////////////////////////////////////</div>
					</div>
					<div class="list_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="300"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="left">
							<img src="../../assets/rsv/24.webp" />
						</div>
						<div class="right">
							<div>●&ensp;25 Test devices in sealed aluminum foil pouch with desiccant</div>
							<div>●&ensp;25 Reagent tubes prefilled with extraction buffer and dropper tips</div>
							<div>●&ensp;25 Sample collection swabs</div>
							<div>●&ensp;1 Positive control swab</div>
							<div>●&ensp;1 Negative control swab</div>
							<div>●&ensp;1 Instructions for Use</div>
							<div>●&ensp;1 Quick Reference Instruction</div>
						</div>
					</div>
				</div>
				<div class="icon" style="left: -80px;top: -80px;">
					<img src="../../assets/rsv/4.webp" style="width: 280px;" />
				</div>
				<div class="icon" style="right: 100px;top: 80px;">
					<img src="../../assets/rsv/4.webp" style="width: 80px;" />
				</div>
				<div class="icon" style="left: 100px;bottom: 80px;">
					<img src="../../assets/rsv/4.webp" style="width: 50px;" />
				</div>
				<div class="icon" style="right: 20px;bottom: 20px;">
					<img src="../../assets/rsv/4.webp" style="width: 180px;" />
				</div>
			</div>
			<!--块2-->
			<!--块3-->
			<div class="block_3">
				<div class="block_3_main">
					<div class="title_box"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="title">TEST PROCEDURE</div>
						<div class="tips">//////////////////////////////////////////////////////////////////////</div>
					</div>
					<div class="list_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="300"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="list_el">
							<img class="bg" src="../../assets/rsv/16.webp" />
							<div class="tit">
								<div class="title">Step 1:</div>
								<div class="text">
									Collect the anterior<br />
									nasal swab sample.
								</div>
							</div>
						</div>
						<div class="list_el">
							<img class="bg" src="../../assets/rsv/17.webp" />
							<div class="tit">
								<div class="title">Step 2:</div>
								<div class="text">
									Stir the swab in<br />
									Reagent tube at<br />
									least <span>10 times</span>.
								</div>
							</div>
						</div>
						<div class="list_el">
							<img class="bg" src="../../assets/rsv/18.webp" />
							<div class="tit">
								<div class="title">Step 3:</div>
								<div class="text">
									Remove the swab<br />
									while squeezing the<br />
									sides of the tube.
								</div>
							</div>
						</div>
					</div>
					<div class="list_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="600"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="list_el">
							<img class="bg" src="../../assets/rsv/19.webp" />
							<div class="tit">
								<div class="title">Step 4:</div>
								<div class="text">
									Attach provided<br />
									dropper tip to close<br />
									the reagent tube.
								</div>
							</div>
						</div>
						<div class="list_el">
							<img class="bg" src="../../assets/rsv/20.webp" />
							<div class="tit">
								<div class="title">Step 5:</div>
								<div class="text">
									Dispense 2 drops<br />
									of sample into the<br />
									sample well of the<br />
									test device.
								</div>
							</div>
						</div>
						<div class="list_el">
							<img class="bg" src="../../assets/rsv/21.webp" />
							<div class="tit">
								<div class="title">Step 6:</div>
								<div class="text">
									Read the results at<br />
									15 minutes visually.
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="icon" style="left: -50px;bottom: 10px;">
					<img src="../../assets/rsv/4.webp" style="width: 180px;" />
				</div>
			</div>
			<!--块3-->
			<!--块4-->
			<div class="block_4">
				<div class="block_4_main">
					<div class="title_box"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="title">TEST RESULTS</div>
						<div class="tips">////////////////////////////////////////////////////////////////////////////</div>
					</div>
					<div class="list_box">
						<div class="list_el"
							data-aos="fade-up"
							data-aos-duration="400"
							data-aos-delay="300"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<div class="left">
								<img src="../../assets/rsv/1.webp" />
							</div>
							<div class="right">
								<div class="title">Positive</div>
								<div class="text">
									If the Control (C) line and the Test (T) line are visible, the test is positive.<br />
								</div>
								<div class="text">
									Any visible faint red or pink test (T) line with a visible control (C) line should be read as positive.
								</div>
							</div>
						</div>
						<div class="list_el"
							data-aos="fade-up"
							data-aos-duration="400"
							data-aos-delay="500"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<div class="left">
								<img src="../../assets/rsv/2.webp" />
							</div>
							<div class="right">
								<div class="title">Negative</div>
								<div class="text">
									If the Control (C) line is visible, but the Test (T) line is not visible, the test is negative. A negative test result indicates that the virus that causes RSV was not detected in the sample.
								</div>
							</div>
						</div>
						<div class="list_el"
							data-aos="fade-up"
							data-aos-duration="400"
							data-aos-delay="700"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<div class="left">
								<img src="../../assets/rsv/3.webp" />
							</div>
							<div class="right">
								<div class="title">Invalid</div>
								<div class="text">
									If a control (C) line is not visible, the test is not valid. Re-test with a new swab
									and a new test cassette.
								</div>
							</div>
						</div>
					</div>
					<div class="bot_box">//////////////////////////////////////////////////////////////////////////////////////////////////////</div>
					<div class="icon" style="left: -140px;bottom: 0px;">
						<img src="../../assets/rsv/4.webp" style="width: 120px;" />
					</div>
				</div>
				<div class="icon" style="right: -80px;bottom: 50px;">
					<img src="../../assets/rsv/4.webp" style="width: 230px;" />
				</div>
			</div>
			<!--块4-->
			<!--块5-->
			<div class="block_5">
				<div class="block_5_main">
					<div class="title"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<img src="../../assets/rsv/5.webp" />
					</div>
					<div class="list_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="300"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<el-collapse accordion>
							<van-collapse v-model="activeNames" :border="false" @change="collChange">
								<van-collapse-item :name="1" :border="false">
									<template #title>
										<div class="title_box">
											<div class="tit">01. Guide Download</div>
										</div>
									</template>
									<template #right-icon>
										<div class="img">
											<img v-if="nowActived.length > 1 || nowActived[0] == 1" src="../../assets/rsv/22.webp" />
											<img v-else src="../../assets/rsv/23.webp" />
										</div>
									</template>
									<div class="content">
										<div class="content_el" @click="downloadUrl(1)">
											<img src="../../assets/rsv/6.webp" />&ensp;<span>Download IFU</span>
										</div>
										<div class="content_el" @click="downloadUrl(2)">
											<img src="../../assets/rsv/6.webp" />&ensp;<span>Download QRI</span>
										</div>
									</div>
								</van-collapse-item>
								<van-collapse-item :name="2" :border="false">
									<template #title>
										<div class="title_box">
											<div class="tit">02. Product Sell Sheet</div>
										</div>
									</template>
									<template #right-icon>
										<div class="img">
											<img v-if="nowActived.length > 1 || nowActived[0] == 2" src="../../assets/rsv/22.webp" />
											<img v-else src="../../assets/rsv/23.webp" />
										</div>
									</template>
									<div class="content">
										<div class="content_el" @click="downloadUrl(3)">
											<img src="../../assets/rsv/6.webp" />&ensp;<span>Download RSV sale Sheet</span>
										</div>
									</div>
								</van-collapse-item>
							</van-collapse>
						</el-collapse>
					</div>
					<div class="icon" style="right: -200px;bottom: 200px;">
						<img src="../../assets/rsv/4.webp" style="width: 80px;" />
					</div>
				</div>
			</div>
			<!--块5-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navbar from '@/component/pc/nav.vue'  //导航组件
import footerBox from '@/component/pc/footer.vue'  //版权组件
import fixed from '@/component/pc/fixed.vue'  //联系我们悬浮
import { productInfo, productCount } from '@/api/public';
import md5 from 'js-md5';
import moment from 'moment';
import download from 'downloadjs';
export default {
	components:{
		navbar,
		footerBox,
		fixed
	},
	metaInfo() {
		return {
			meta: [
				{
					name: "description",
					content: this.metaDescription,
				},{
					name: "keywords",
					content: this.metaKeywords,
				}
			]
		}
	},
	data() {
		return {
			isLoading: true,  //界面loading
			infoData: null,
			nowList: null,
			nowContent: '',
			metaDescription: '',
			metaKeywords: '',
			nowActived: [1, 2],
			activeNames: [1, 2],
		}
	},
	created(){
		let that = this;
		window.scroll(0, 0);
		//请求产品信息
		productInfo({
			custom: that.$route.name
		}).then(res => {
			that.infoData = res.data;
			document.title = res.data.title + ' - CorDx';
			that.metaDescription = res.data.description;
			that.metaKeywords = res.data.keywords;
			that.setOgTag('og:locale', 'en_US');
			that.setOgTag('og:title', res.data.title);
			that.setOgTag('og:description', res.data.description);
			that.setOgTag('og:image', res.data.url);
			that.setOgTag('og:image:width', '1200');
			that.setOgTag('og:image:height', '630');
			that.setOgTag('og:image:type', 'webp');
			if(that.infoData.tags.length > 0) {
				that.nowList = that.infoData.tags[0].id;
				that.nowContent = that.infoData.tags[0].content;
			}
			that.isLoading = false;
			//统计访问
			let time = String(moment(new Date()).valueOf());
			setTimeout(() => {
				productCount({
					language: sessionStorage.getItem('lang') == 'en' ? 2 : 1,
					cate_id: that.infoData.cate_id,
					cert_id: that.infoData.cert_id,
					productid: that.infoData.id,
					url: that.$route.name,
					addtime: time,
					sign: md5(String(that.infoData.cate_id) + String(that.infoData.cert_id) + String(that.infoData.id) + that.$route.name + String(time) + 'CorDx2023'),
				}).then(res2 => {});
			}, 10000);
		});
	},
	mounted() {
		let that = this;
	},
	watch: {
		//
	},
	methods: {
		downloadUrl(value) {
			let that = this;
			switch(value) {
				case 1:
					download('https://cordx.com/files/CorDx-RSV-Test-IFU.pdf');
				break;
				case 2:
					download('https://cordx.com/files/CorDx-RSV-Test-QRI.pdf');
				break;
				case 3:
					download('https://cordx.com/files/RSV-sale-sheet.pdf?t=20251020');
				break;
			}
		},
		//折叠面板点击
		collChange(activeNames) {
			let that = this;
			that.nowActived = activeNames;
		},
		isHas(id) {
			let that = this;
			if(that.nowActived.length > 0) {
				let str = null;
				that.nowActived.forEach((value, index) => {
					if(value == id) {
						str = 1;
					}
				});
				if(str == 1) {
					return true;
				}else {
					return false;
				}
			}else {
				return false;
			}
		},
		//设置OG标签
		setOgTag(property, content) {
			const meta = document.querySelector(`meta[property='${property}']`);
			if(meta) {
				meta.setAttribute('content', content);
			} else {
				const newMeta = document.createElement('meta');
				newMeta.setAttribute('property', property);
				newMeta.setAttribute('content', content);
				document.head.appendChild(newMeta);
			}
		},
		goContact() {
			this.$router.push({ path: '/contact' });
		}
	}
}
</script>

<style scoped lang="less">
.main_box{
	//块5
	.block_5{
		.block_5_main{
			width: 1140px;
			margin: 0 auto;
			padding: 80px 0;
			position: relative;
			.list_box{
				padding-top: 60px;
				.img{
					img{
						width: 50px;
						position: relative;
						top: 22px;
					}
				}
				.content{
					padding: 0px 0 20px 0;
					.content_el{
						margin: 0px 0 24px 0;
						cursor: pointer;
						user-select: none;
						span{
							color: #666666;
							font-size: 24px;
							position: relative;
							top: 8px;
							left: 5px;
						}
						img{
							width: 42px;
						}
					}
				}
				.title_box{
					// border-bottom: 1px solid #969799;
					.tit{
						padding: 30px 0 30px 0;
						font-size: 36px;
						font-weight: bold;
						user-select: none;
						line-height: 1;
					}
				}
			}
			.title{
				text-align: center;
				img{
					width: 738px;
				}
			}
		}
	}
	//块4
	.block_4{
		overflow: hidden;
		position: relative;
		.block_4_main{
			width: 1140px;
			margin: 0 auto;
			padding: 80px 0 0px 0;
			position: relative;
			.bot_box{
				max-width: 100%;
				overflow: hidden;
				color: #EBEBEB;
				font-size: 32px;
			}
			.list_box{
				padding: 40px 0 100px 0;
				.list_el{
					display: flex;
					align-items: center;
					padding: 10px 0;
					.right{
						flex: 1;
						padding-left: 50px;
						.text{
							padding-top: 10px;
							font-size: 24px;
						}
						.title{
							font-size: 36px;
							font-weight: bold;
						}
					}
					.left{
						width: 315px;
						text-align: right;
						overflow: hidden;
						img{
							height: 220px;
							max-width: 100%;
						}
					}
				}
			}
			.title_box{
				display: flex;
				align-items: center;
				.title{
					width: auto;
					font-size: 48px;
					color: #B22F43;
					font-weight: bold;
				}
				.tips{
					flex: 1;
					padding-left: 30px;
					font-size: 30px;
					color: #EBEBEB;
				}
			}
		}
	}
	//块3
	.block_3{
		overflow: hidden;
		position: relative;
		.block_3_main{
			width: 1140px;
			margin: 0 auto;
			padding: 100px 0 0px 0;
			.list_box{
				display: flex;
				align-items: start;
				padding-top: 50px;
				.list_el{
					flex: 1;
					display: flex;
					.tit{
						flex: 1;
						padding-left: 10px;
						.text{
							padding-top: 5px;
							font-size: 16px;
							span{
								font-size: 18px;
								font-weight: bold;
							}
						}
						.title{
							font-weight: bold;
							font-size: 18px;
						}
					}
					.bg{
						width: 150px;
					}
				}
			}
			.title_box{
				display: flex;
				align-items: center;
				.title{
					width: auto;
					font-size: 48px;
					color: #B22F43;
					font-weight: bold;
				}
				.tips{
					flex: 1;
					padding-left: 30px;
					font-size: 30px;
					color: #EBEBEB;
				}
			}
		}
	}
	//块2
	.block_2{
		overflow: hidden;
		position: relative;
		.block_2_main{
			width: 1140px;
			margin: 0 auto;
			padding: 120px 0 0px 0;
			.list_box{
				display: flex;
				padding-top: 50px;
				.right{
					padding-left: 30px;
					div{
						padding: 5px 0;
						font-size: 24px;
					}
				}
				.left{
					img{
						width: 415px;
					}
				}
			}
			.title_box{
				display: flex;
				align-items: center;
				.title{
					width: auto;
					font-size: 48px;
					color: #B22F43;
					font-weight: bold;
				}
				.tips{
					flex: 1;
					padding-left: 30px;
					font-size: 30px;
					color: #EBEBEB;
				}
			}
		}
	}
	//块1
	.block_1{
		background-color: #F8E5E5;
		.block_1_main{
			padding: 70px 0;
			.list_box{
				display: flex;
				justify-content: center;
				.list_el{
					width: auto;
					padding: 0 45px;
					text-align: center;
					div{
						padding-top: 10px;
						font-size: 30px;
						color: #B22F43;
					}
					img{
						width: 96px;
					}
				}
			}
		}
	}
	//banner
	.banner_box{
		position: relative;
		.img_box{
			width: 1040px;
			margin: 0 auto;
			padding: 0 0 100px 0;
			text-align: center;
			.title{
				width: 100%;
				padding-bottom: 20px;
				img{
					width: 640px;
				}
			}
			.img{
				width: 100%;
			}
		}
		.banner_main{
			width: 1140px;
			margin: 0 auto;
			display: flex;
			align-items: center;
			padding: 80px 0 80px 0;
			.left{
				flex: 1;
				.list_box{
					display: flex;
					align-items: center;
					padding-top: 25px;
					.list_el{
						flex: 1;
						display: flex;
						align-items: center;
						div{
							position: relative;
							top: 2px;
							padding-left: 10px;
							font-size: 20px;
						}
						img{
							width: 30px;
						}
					}
				}
				.btn_box{
					padding-top: 10px;
					img{
						width: 240px;
						cursor: pointer;
					}
				}
				.rz_box{
					padding: 25px 0 25px 0;
					img{
						width: 260px;
					}
				}
				.text{
					padding-top: 10px;
					font-size: 24px;
				}
				.title2{
					img{
						width: 92%;
					}
				}
				.title1{
					font-size: 54px;
					font-weight: bold;
					color: #000000;
					line-height: 1;
				}
			}
			.right{
				flex: 1;
				padding-left: 50px;
			}
		}
	}
	//引导块
	.tips_box{
		padding: 50px 0 30px 0;
		background: linear-gradient(to right, #F2F7FD, transparent);
		.tips_main{
			width: 1140px;
			margin: 0 auto;
			font-size: 18px;
			span{
				color: #0B318F;
				font-size: 18px;
			}
		}
	}
	.icon{
		position: absolute;
	}
}
</style>
<style scoped>
>>> .main_box ol,>>> .main_box ul{
	list-style: initial !important;
	margin: revert !important;
	padding: revert !important;
}
>>> .main_box .block_1_box p{
	margin: 0;
}
>>> .block_5 .el-collapse{
	border: none;
	/* border-bottom: 1px solid #999999; */
}
>>> .block_5 .van-collapse-item{
	border-bottom: 1px solid #999999;
}
>>> .block_5 .van-cell{
	padding: 0;
	line-height: normal;
}
>>> .block_5 .van-collapse-item__content{
	padding: 0;
}
</style>